import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const ConnectionText = styled(Text)`
    min-width: 0;
    flex: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.3;
`;
